import config from "@/config"
import http from "@/utils/request"

export default {
  goods: {
    list: {
      url: `${config.API_URL}/goods`,
      name: "获取用户",
      get: async function (params) {
        return await http.get(`${this.url}/listAll`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/update`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      }
    }
  }
}
